import type { AssistantInfo } from "../../services/api/instances/assistantsApi/types";

export const sortAssistantData = (
  assistantList: AssistantInfo[] = []
): AssistantInfo[] => {
  return assistantList
    .filter((assistant) => assistant.metadata)
    .sort((a, b) => a?.name?.localeCompare(b.name));
};
